<template>

</template>

<script>
import Vue from 'vue'
let State = new Vue({
  data() {
    return {
      uuid: '',
      api_key:'Girliaefpqp!$TUJi^#@888'
    }
  },
})
export default {
  State,
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/utils/book_global.vue